import { noop } from "lodash";
import { processErrorFromPromise } from "../errors/utils";
import { merchantEffects } from "../merchants/effects";
import { participationEffects } from "../participations/effects";
import { globalStore } from "./global-store";
import { ofType } from "./of-type.operator";
import { verificationEffects } from "../verification/effects";

export const runAllSubscriptions = () => [
  ...merchantEffects,
  ...participationEffects,
  ...verificationEffects,
  globalStore
    .pipe(ofType("ERROR"))
    .subscribe((payload) => processErrorFromPromise(payload).catch(noop)),
];
